import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { NotificationService } from '@core/services/notification.service';
import { API_CONTEXT_TOKEN } from '@core/constants';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  notification = inject(NotificationService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const context = request.context.get(API_CONTEXT_TOKEN);
        let message: string;

        if (context) {
          message = this.notification.getMessage(`${context}.error`);
          this.notification.errorMessage(message);
        } else {
          message = this.notification.getMessage(`api.${error.status}`) || this.notification.getMessage('generalError');
        }

        return throwError(() => ({ ...error, message }));
      })
    );
  }
}
